import React from 'react';
import './Global.css';
import { FaCheckCircle } from 'react-icons/fa';
import worldMapImage from '../../assets/images/map-7453623.png'; // Ensure correct path

const WhyCEDCoatings = () => {
  const reasons = [
    'We are a young team of practiced professionals.',
    'Our approach is completely customer-centric.',
    'Our plant is equipped for mass output of nearly 25 tons per day.',
    'Hi-tech plant with latest technology equipment.',
    'Complete in-house lab facility for paint & coating.',
    'Nearly 98% paint utilization ensures minimal wastage.',
    'Max single job size: 4700(L) x 1800(W) x 1700(H) mm — up to 1000 kg.',
    'Equipped with the most advanced safety features.',
    'Coating capacity of 300 m²/hour, expandable to 375 m²/hour.',
    'Timely delivery is our commitment to customers.'
  ];

  const stats = [
    { value: '10+', label: 'YEARS OF EXPERIENCE' },
    { value: '500+', label: 'PROJECTS COMPLETED' },
    { value: '100%', label: 'CUSTOMER SATISFACTION' }
  ];

  return (
    <section className="why-ced-container">
      <header className="why-ced-header">
        <h2 className="why-ced-title">
          WHY CHOOSE CED COATINGS?
        </h2>
        <div className="underline"></div>
      </header>

      <div className="why-ced-content">
        <div className="why-ced-text">
          <h1 className="why-ced-subtitle">
            PREMIER GLOBAL EXPORTER OF <br /> CUTTING-EDGE CED COATING SOLUTIONS
          </h1>
          <ul className="why-ced-list">
            {reasons.map((reason, index) => (
              <li key={index} className="why-ced-list-item">
                <FaCheckCircle className="check-icon" />
                <span>{reason}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="why-ced-map-wrapper">
          <img 
            src={worldMapImage} 
            alt="Global Presence Map" 
            className="world-map-img" 
          />
          {/* Only one red dot marking India */}
          <span className="red-dot" style={{ top: '47%', left: '65%' }}></span>
        </div>
      </div>

      <div className="why-ced-stats">
        {stats.map((stat, index) => (
          <div className="stat-item" key={index}>
            <h3>{stat.value}</h3>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyCEDCoatings;
